import * as types from '../../../actions';

const initialState = {
    items: [],
    status:0,
    totalPage:0,
    numRows:0,
    item:{
      id:'',
      locationName:'',
      streetOne:'',
      streetTwo:'',
      city:'',
      state:'',
      country:'',
      postcode:''
    },
    activity:'',
    masterLocations:[],  
    count:'',
    errorData:'',
    successData:''
};

export default function(state = initialState, action) {
  const response = action.response;
  switch(action.type) {

      case types.EVENT_LOCATION_LIST_SUCCESS:
            if(response.status===200){
                let totalPage = Math.ceil(response.data.count/response.data.page_size);
                return {
                    ...state,
                    items: response.data.results,
                    status: response.status,
                    activity:types.EVENT_LOCATION_LIST_SUCCESS,
                    totalPage: totalPage,
                    numRows:response.data.results.length,
                    count:response.data.count               
                };
            }else{
                return {
                    ...state,
                    activity:types.EVENT_LOCATION_LIST_ERROR,
                    status: response.status,                                 
                };
            }  

        case types.EVENT_LOCATION_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    items: [...state.items],
                    status: response.status,
                    activity:types.EVENT_LOCATION_ADD_SUCCESS,
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.EVENT_LOCATION_ADD_ERROR,
                    errorData: response.data,  
                }
            }
        case types.EVENT_LOCATION_DELETE_SUCCESS:
            const id = response.data.id;          
            if(response.status===200){        
                return {
                    ...state,
                    items: state.items.filter(items => items.id !== id),                
                    status: response.status,
                    activity:types.EVENT_LOCATION_DELETE_SUCCESS,   
                }
            }else{
                return {
                    ...state,
                    status: response.status,
                    activity:types.EVENT_LOCATION_DELETE_ERROR,   
                    errorData: response.data,  
                }
            }
        case types.MASTER_LOCATION_LIST_SUCCESS:
            return {
                ...state,
                status:response.status,
                masterLocations:response.data,
                activity:types.MASTER_LOCATION_LIST_SUCCESS,
            }  
        case types.EVENT_LOCATION_IMPORT_SUCCESS:
            if(response.status===200){      
                return {
                    ...state,
                    status:response.status,
                    activity:types.EVENT_LOCATION_IMPORT_SUCCESS,
                    successData:response.data,
                }    
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.EVENT_LOCATION_IMPORT_ERROR,
                    errorData: response.data,  
                }    
            }
              
        case types.CLEAR:
            return {
                ...state,
                item:{
                    id:'',
                    locationName:'',
                    streetOne:'',
                    streetTwo:'',
                    city:'',
                    state:'',
                    country:'',
                    postcode:''
                },
                activity:types.CLEAR,
                status:0               
           }  

        default:
          return state;
  }
};